export default {
  name: 'funnelChart',
  state: {
    counter: 0,
  },
  reducers: {
    inc(state) {
      return {
        ...state,
        counter: state.counter + 1,
      };
    },
    dec(state) {
      return {
        ...state,
        counter: state.counter - 1,
      };
    },
  },
};
